/** @format */

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

//import table data
import {
  tableColumnGuarantor,
  tableColumnGuarantor2,
} from "../../components/table/col-data";
import { ToggleBtn } from "../../components/global/btns/btns";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";

const MangerAccess = () => {
  return (
    <NavbarAndSidebar>
      <HeadTitle title='صلاحيات المشرف' />
      <div className='mb__small' />
      <div className='manger-access'>
        <div className='flex-between'>
          <HeadTitle small={true} title='تعديل بيانات الكفيل' />
          <ToggleBtn />
        </div>
        <div className='flex-between'>
          <HeadTitle small={true} title='حظر كفيل' />
          <ToggleBtn />
        </div>
        <div className='flex-between'>
          <HeadTitle small={true} title='  مراجعة اوراق الكفيل' />
          <ToggleBtn />
        </div>
        <div className='flex-between'>
          <HeadTitle small={true} title=' اضافة خدمه ' />
          <ToggleBtn />
        </div>
        <div className='flex-between'>
          <HeadTitle small={true} title=' تعديل خدمه ' />
          <ToggleBtn />
        </div>
      </div>
    </NavbarAndSidebar>
  );
};
export default MangerAccess;
